import React from 'react';
import { ChakraProvider, Box } from '@chakra-ui/react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

// Pages
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import SettingsPage from './pages/SettingsPage';
import FeesPage from './pages/FeesPage';

// Components
import PrivateRoute from './components/PrivateRoute';
import Layout from './components/Layout';

// Contexts
import { AuthProvider } from './contexts/AuthContext';
import { SdkProvider } from './contexts/SdkContext';
import { DevPreviewProvider } from './contexts/DevPreviewContext';

// Theme
import theme from './theme';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

function App() {
  return (
    <ChakraProvider theme={theme}>
      <AuthProvider>
        <SdkProvider>
          <DevPreviewProvider>
            <QueryClientProvider client={queryClient}>
              <Router>
                <Box minH="100vh">
                  <Routes>
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/login/verify" element={<LoginPage />} />
  
                    {/* Protected Routes */}
                    <Route element={<Layout />}>
                      <Route
                        path="/dashboard"
                        element={
                          <PrivateRoute>
                            <DashboardPage />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path="/settings"
                        element={
                          <PrivateRoute>
                            <SettingsPage />
                          </PrivateRoute>
                        }
                      />
                      <Route
                        path="/fees"
                        element={
                          <PrivateRoute>
                            <FeesPage />
                          </PrivateRoute>
                        }
                      />
                      <Route path="/analytics" element={<Navigate to="/fees" replace />} />
                      <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    </Route>
                  </Routes>
                </Box>
              </Router>
            </QueryClientProvider>
          </DevPreviewProvider>
        </SdkProvider>
      </AuthProvider>
    </ChakraProvider>
  );
}

export default App; 